<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  modelValue: {
    type: String,
    default: 'companies',
  },
});

const emit = defineEmits(['update:modelValue']);
const { t } = useI18n();

const options = computed(() => [
  { id: 'companies', name: t('CONTACT_REPORTS.MODE.COMPANIES') },
  { id: 'contacts', name: t('CONTACT_REPORTS.MODE.CONTACTS') },
]);

const selectedOption = computed({
  get() {
    return options.value.find(option => option.id === props.modelValue);
  },
  set(option) {
    if (option?.id) emit('update:modelValue', option.id);
  },
});
</script>

<template>
  <div class="multiselect-wrap--small">
    <multiselect
      v-model="selectedOption"
      class="no-margin"
      track-by="id"
      label="name"
      :placeholder="$t('CONTACT_REPORTS.MODE.PLACEHOLDER')"
      selected-label
      :select-label="$t('FORMS.MULTISELECT.ENTER_TO_SELECT')"
      deselect-label=""
      :options="options"
      :searchable="false"
      :allow-empty="false"
    />
  </div>
</template>
